import { render, staticRenderFns } from "./pageSidebar.vue?vue&type=template&id=167d0cca&scoped=true"
import script from "./pageSidebar.vue?vue&type=script&lang=js"
export * from "./pageSidebar.vue?vue&type=script&lang=js"
import style0 from "./pageSidebar.vue?vue&type=style&index=0&id=167d0cca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "167d0cca",
  null
  
)

export default component.exports